import React from 'react'
import { LessonSection, MiniTestSection, } from './'
import uuid from 'uuid/v1'

export default function ChapterSection({ sectionType, sectionTitle, sectionContent }) {


// const markup = {sectionContent} ? CreateMarkup({sectionContent}) : {__html: '<p></p>'}


  return (
    <div>

      {/* If the Chapter section is a Lesson, render out a <LessonContent> component. */}
      {
         sectionType === 'Lesson' &&
         <LessonSection
            lessonTitle={sectionTitle}
            sectionContent={sectionContent}
         />
      }

      {/* If the Chapter section is a Mini-Test, render out a <MiniTestContent> component. */}
      {
         sectionType === 'Mini-Test' &&
         <MiniTestSection
            miniTestTitle={sectionTitle}
            sectionContent={sectionContent}
         />
      }

      {/* {sectionContent.map((content, i) =>
         (<div>{content['itemType']}</div>)
      )} */}

      {/* <div
          dangerouslySetInnerHTML={CreateMarkup({sectionContent})}
        /> */}

    </div>
  )
}


// WEBPACK FOOTER //
// ./src/components/BookPrint/ChapterSection.js